import { createSlice } from '@reduxjs/toolkit';

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes cache
const TEMPLATE_LIMIT = 50;

const initialState = {
  activeCategory: "utility", // utility | marketing | authentication
  statusFilter: "all", // all | approved | pending | rejected
  searchQuery: "",
  
  categoryData: {
    utility: {
      templates: [],
      loading: false,
      error: null,
      lastEvaluatedKey: null,
      hasMore: true,
      limit: TEMPLATE_LIMIT,
      cachedAt: null,
    },
    marketing: {
      templates: [],
      loading: false,
      error: null,
      lastEvaluatedKey: null,
      hasMore: true,
      limit: TEMPLATE_LIMIT,
      cachedAt: null,
    },
    authentication: {
      templates: [],
      loading: false,
      error: null,
      lastEvaluatedKey: null,
      hasMore: true,
      limit: TEMPLATE_LIMIT,
      cachedAt: null,
    },
    library: {
      templates: [],
      loading: false,
      error: null,
      cachedAt: null,
    },
  },
};

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
    setStatusFilter: (state, action) => {
      state.statusFilter = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    
    fetchTemplatesStart: (state, action) => {
      const category = action.payload || state.activeCategory;
      state.categoryData[category].loading = true;
      state.categoryData[category].error = null;
    },
    
    fetchTemplatesSuccess: (state, action) => {
      const { category, templates, lastEvaluatedKey, hasMore } = action.payload;
      state.categoryData[category].templates = templates;
      state.categoryData[category].lastEvaluatedKey = lastEvaluatedKey;
      state.categoryData[category].hasMore = hasMore;
      state.categoryData[category].loading = false;
      state.categoryData[category].error = null;
      state.categoryData[category].cachedAt = Date.now(); // Set cache timestamp
    },
    
    fetchTemplateLibraryStart: (state) => {
      state.categoryData.library.loading = true;
      state.categoryData.library.error = null;
    },
    
    fetchTemplateLibrarySuccess: (state, action) => {
      state.categoryData.library.templates = action.payload.templates;
      state.categoryData.library.loading = false;
      state.categoryData.library.error = null;
      state.categoryData.library.cachedAt = Date.now();
    },
    
    fetchTemplateLibraryError: (state, action) => {
      state.categoryData.library.error = action.payload.error;
      state.categoryData.library.loading = false;
    },
    
    appendTemplates: (state, action) => {
      const { category, templates, lastEvaluatedKey, hasMore } = action.payload;
      state.categoryData[category].templates.push(...templates);
      state.categoryData[category].lastEvaluatedKey = lastEvaluatedKey;
      state.categoryData[category].hasMore = hasMore;
      state.categoryData[category].loading = false;
    },
    
    fetchTemplatesError: (state, action) => {
      const category = action.payload.category || state.activeCategory;
      state.categoryData[category].error = action.payload.error;
      state.categoryData[category].loading = false;
    },
    
    resetCategoryData: (state, action) => {
      const category = action.payload;
      state.categoryData[category] = {
        templates: [],
        loading: false,
        error: null,
        lastEvaluatedKey: null,
        hasMore: true,
        limit: TEMPLATE_LIMIT,
        cachedAt: null,
      };
    },
  }
});

export const { 
  setCategory, 
  setStatusFilter, 
  setSearchQuery, 
  fetchTemplatesStart, 
  fetchTemplatesSuccess,
  appendTemplates,
  fetchTemplatesError,
  resetCategoryData,
  fetchTemplateLibraryStart,
  fetchTemplateLibrarySuccess,
  fetchTemplateLibraryError
} = templatesSlice.actions;

export { CACHE_TTL_MS, TEMPLATE_LIMIT };
export default templatesSlice.reducer;